import { createContext } from "react";

import { ImagingRequestHelper } from "./ImagingRequestHelper.ts";

export const ImagingRequestContext = createContext<ImagingRequestHelper>(
  {} as ImagingRequestHelper
);
